import {getShowPrice} from "../utils/get_show_price";
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";

interface IUseShouldShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

/**
 * Hook that determines if price should be shown based on:
 * - Offer and vendor price visibility configuration
 * - Vendor exclusion list
 */
export const useShouldShowPrice = (params: IUseShouldShowPriceParams): boolean => {
    const {offerPriceVisibility = PriceVisibilityType.ALWAYS, vendorPriceVisibility = PriceVisibilityType.AUTO, vendorId} = params;

    return getShowPrice({
        offerPriceVisibility,
        vendorPriceVisibility,
        vendorId
    });
};
import {getShowPrice} from "../utils/get_show_price";
import {PriceVisibilityType} from "../vendor/types/PriceVisibilityType";

interface IUseShouldShowPriceParams {
    offerPriceVisibility?: PriceVisibilityType;
    vendorPriceVisibility?: PriceVisibilityType;
    vendorId: number;
}

/**
 * Hook that determines if price should be shown based on:
 * - Offer and vendor price visibility configuration
 * - Vendor exclusion list
 */
export const useShouldShowPrice = (params: IUseShouldShowPriceParams): boolean => {
    const {offerPriceVisibility = PriceVisibilityType.ALWAYS, vendorPriceVisibility = PriceVisibilityType.AUTO, vendorId} = params;

    return getShowPrice({
        offerPriceVisibility,
        vendorPriceVisibility,
        vendorId
    });
};
